import { useState, useEffect } from 'react';
import { Inbox, Megaphone, FileText, Smartphone } from 'lucide-react';
import InboxWhatsapp from './InboxWhatsapp';
import DisparoWhatsapp from './DisparoWhatsapp';
import TemplatesWhatsapp from './TemplatesWhatsapp';
import MeuWhatsapp from './MeuWhatsapp';
import { UserSession } from '../../../types';

interface CRMComunicacaoProps {
  session?: UserSession | null;
  initialInboxNumero?: string;
  onInboxNumeroConsumed?: () => void;
}

type AbaId = 'inbox' | 'disparo' | 'templates' | 'meu';

const CRMComunicacao = ({ session, initialInboxNumero, onInboxNumeroConsumed }: CRMComunicacaoProps) => {
  // If a numero was passed (from CarteiraGix via App.tsx), start on inbox tab
  const [aba, setAba] = useState<AbaId>(initialInboxNumero ? 'inbox' : 'meu');
  const [inboxNumero, setInboxNumero] = useState<string | undefined>(initialInboxNumero);

  // If the prop changes (user clicks another contact while already on this section)
  useEffect(() => {
    if (initialInboxNumero) {
      setInboxNumero(initialInboxNumero);
      setAba('inbox');
    }
  }, [initialInboxNumero]);

  const tabs: { id: AbaId; name: string; icon: any; descr: string }[] = [
    { id: 'meu', name: 'Meu WhatsApp', icon: Smartphone, descr: 'Conecte seu número pessoal' },
    { id: 'inbox', name: 'Inbox', icon: Inbox, descr: 'Mensagens recebidas e conversas' },
    { id: 'disparo', name: 'Disparo', icon: Megaphone, descr: 'Envio em massa filtrado' },
    { id: 'templates', name: 'Templates', icon: FileText, descr: 'Modelos de mensagem' },
  ];

  return (
    <div className="p-4 sm:p-6">
      <div className="mb-4">
        <h1 className="text-2xl font-bold text-gray-900">Comunicação CRM</h1>
        <p className="text-sm text-gray-600">WhatsApp integrado à sua carteira</p>
      </div>

      <div className="flex gap-1 border-b border-gray-200 mb-4">
        {tabs.map(t => {
          const Icon = t.icon;
          return (
            <button key={t.id} onClick={() => setAba(t.id)}
              className={`px-4 py-2.5 text-sm font-medium border-b-2 -mb-px flex items-center gap-2 ${
                aba === t.id ? 'border-green-600 text-green-700' : 'border-transparent text-gray-600 hover:text-gray-900'
              }`}>
              <Icon className="h-4 w-4" /> {t.name}
            </button>
          );
        })}
      </div>

      {aba === 'meu' && <MeuWhatsapp session={session} />}
      {aba === 'inbox' && <InboxWhatsapp session={session} initialNumero={inboxNumero} onNumeroConsumed={() => { setInboxNumero(undefined); onInboxNumeroConsumed?.(); }} />}
      {aba === 'disparo' && <DisparoWhatsapp session={session} />}
      {aba === 'templates' && <TemplatesWhatsapp session={session} />}
    </div>
  );
};

export default CRMComunicacao;
